import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const UpdateInfluencerSocialMedia = (
  userId: string,
  socialMediaId: string,
  data: {
    [key: string]: string | number | boolean | null
  },
) => {
  return apiInstance.put(
    ApiPathConfig.INFLUENCER_SOCIAL_MEDIA_BY_ID(userId, socialMediaId),
    data,
  )
}

export default UpdateInfluencerSocialMedia
